import React, { useState, useEffect, useCallback } from 'react';
import Container from '@material-ui/core/Container';

import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Cookies from 'js-cookie';

import { MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { Button } from '@mui/material';
import { useHistory } from "react-router-dom";
import moment from 'moment';
import { useParams } from "react-router-dom";
import Typography from '@material-ui/core/Typography';
import Autocomplete from '@material-ui/lab/Autocomplete';
import SettingsIcon from '@mui/icons-material/Settings';
import Skeleton from '@material-ui/lab/Skeleton';
import IconButton from '@material-ui/core/IconButton';
import AppBar from '@mui/material/AppBar';
import ContentCopyIcon from '@mui/icons-material/ContentCopy'; // <-- importar ícone de clonar

import api from '../../../../../services/api';
import NavegadorGestao from "../../../../../components/NavBarGestao";

import miniatura_pdf from '../../../../../assets/imgs/miniatura_pdf.png';
import CabecalhoInformacoes from './CabecalhoInformacoes.js';


import {
    DataGrid,  
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid';


import Box from '@material-ui/core/Box';
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

const dropzoneStyles = {
    border: '2px dashed #cccccc',
    borderRadius: '4px',
    padding: '20px',
    textAlign: 'center',
    cursor: 'pointer',
    margin: '20px 0',
};

export default function EditarProjeto() {

    const [loading, setLoading] = useState(true);

    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);

    }


    const handleChangeIndex = (index) => {
        setValue(index);
    };



    const history = useHistory();

    
    const { telaRetorno } = useParams();
    const { idInstalacao } = useParams();
    const {idCliente} = useParams();
    const { idProjeto } = useParams();
    

    const [nomeProjeto, setNomeProjeto] = useState('');

    const [area, setArea] = useState(0);
    const [clienteSelecionado, setClienteSelecionado] = useState({});
    const [descricaoProjeto, setDescricaoProjeto] = useState('');
    const [clientes, setClientes] = useState([]);
    const [propostas, setPropostas] = useState([]);
    const [instalacao, setInstalacao] = useState([]);

    const [instalacoes, setInstalacoes] = useState([]);
    const [projeto, setProjeto] = useState(null);

      const returnDescricaoStatusProposta = (status_proposta) => {
  const statusMap = {
    0: "Aberta",
    1: "Elaborada",
    2: "Aguardando Aprovação",
    3: "Aprovada",
    9: "Cancelada"
  };
  
  return statusMap[status_proposta] || "Status Desconhecido";
};

    async function listarInformacoes() {
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            await api.get("/v1/protected/projetos/listarporidsimples/" + idProjeto, {
                headers: headers
            }).then(function (response) {

                setProjeto(response.data);
                setArea(response.data.area);
                setDescricaoProjeto(response.data.descricao_projeto);
                setClienteSelecionado(response.data.cliente);
                //setInstalacoes(response.data.projeto.cliente.instalacoes);
                setNomeProjeto(response.data.nome_projeto);
                setPropostas(response.data.propostas);
                //console.log(JSON.stringify(response.data.projeto.propostas));
                setInstalacao(response.data.instalacao);

 

                setLoading(false);
            });
        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar informações: " + _err)

        }

    }



    function returnDescricaoCliente(cliente) {
        var texto = "ID: " + cliente.id_cliente + " " +
            (cliente.tipo_cliente === 0 ? ("CPF: " + cliente.cpf) : ("CNPJ: " + cliente.cnpj)) + " " +
            (cliente.tipo_cliente === 0 ? (cliente.nome + " " + cliente.sobrenome) : cliente.nome_fantasia);

        return texto;
    }

    useEffect(() => {
        listarInformacoes();


    }, []);


      
    async function handleClickClonar (cellValues) {

       
    };




    async function baixarArquivo(caminho) {
        try {
            const token = Cookies.get('token');
            const headers = {
                'Authorization': 'Bearer ' + token
            }

            const response = await api.post("/v1/protected/projetos/baixarPdf", { caminho: encodeURIComponent(caminho) }, {
                headers: headers,
                responseType: 'arraybuffer',  // Indica que a resposta é um array de bytes
            });

            // Cria um blob com os dados recebidos
            const blob = new Blob([response.data], { type: 'application/pdf' });

            // Cria uma URL do blob
            const blobUrl = URL.createObjectURL(blob);

            // Abre uma nova guia com o arquivo PDF
            window.open(blobUrl, '_blank');
        } catch (error) {
            // Trate os erros conforme necessário
            console.log("Erro ao baixar o arquivo: " + error);
        }
    }






    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <GridToolbarExport />
            </GridToolbarContainer>
        );
    }


    const handleCellClick = (param, event) => {
        event.stopPropagation();
    };

    const handleRowClick = (param, event) => {
        event.stopPropagation();
    };


    const handleClickGerenciarProposta = (cellValues) => {

        //"tas/editarproposta/:idProposta/:idProjeto/:telaRetorno/:idInstalacao/:idCliente""
        window.location.href = "/gestao/administracao/projetos/editarprojeto/" + idProjeto + 
        "/propostas/editarproposta/" + cellValues.row.id_proposta + "/1/" + idInstalacao + "/" + idCliente  ;

    };


    


    function novaProposta() {
        window.location.href = "/gestao/administracao/projetos/editarprojeto/" + idProjeto + "/proposta/cadastrarproposta";

    }


    function returnDescricaoInstalacao(instalacao) {
        var texto = "ID_Integrador: " + instalacao.identificador_integrador + "\n Instalacao_ID: " + instalacao.id_instalacao + "\n CPF/CNPJ: " + (instalacao.tipo_instalacao === 0 ? instalacao.cpf : instalacao.cnpj) +
            "\n Nome/Nome Fantasia: " + (instalacao.tipo_instalacao === 0 ? (instalacao.nome + " " + instalacao.sobrenome) : instalacao.nome_fantasia);

        return texto;
    }



    

    function returnDescricaoRetorno(instalacao) {
        var texto = instalacao.identificador_integrador +  " | " + (instalacao.tipo_instalacao === 0 ? instalacao.cpf : instalacao.cnpj) +
            " | " + (instalacao.tipo_instalacao === 0 ? (instalacao.nome + " " + instalacao.sobrenome) : instalacao.nome_fantasia);

        return texto;
    }


    
     const columnsPropostasDataGrid = [
            {
                field: 'acoes',
                headerName: 'Ações',
                headerClassName: 'cabecalho_marrom_claro',
                sortable: false,
                width: 100,
              renderCell: (cellValues) => {
    return (
         
           <IconButton color="error" onClick={() => handleClickGerenciarProposta(cellValues)}>
                <SettingsIcon />
            </IconButton>
            
       
    );
},
            },
            {
                headerName: 'ID',
                field: 'id_proposta',
                id: 1,
                width: 50,
                headerClassName: 'cabecalho_azul',
            },
            {
                headerName: 'Status',
                field: 'status_proposta',
                id: 2,
                minWidth: 120,
                flex: 1,
                headerClassName: 'cabecalho_azul',
                valueFormatter: (params) => {
                  const rawValue = params;
                  const status = Number.isInteger(rawValue) ? rawValue : parseInt(rawValue, 10);
              
                 

                  return returnDescricaoStatusProposta(status);
                },
              },
              
            {
                headerName: 'Descrição',
                field: 'descricao_proposta',
                id: 1,
                width: 600,
                headerClassName: 'cabecalho_azul',
            },
            {
                headerName: 'Valor Total',
                field: 'valor',
                width: 150,
                headerClassName: 'cabecalho_azul',
                renderCell: (params) => {
                  const valorFormatado = params.value?.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  });
              
                  return (
                    <span style={{ fontWeight: 'bold', fontSize: '1rem' }}>
                      {valorFormatado}
                    </span>
                  );
                },
              },
    
     
    
        ];
    
    

    return (
        <div>

            <NavegadorGestao
                BaseDados={true}
                Projetos={true}
                corFundo={'white'} travado={true} corTexto={'black'}

            />
            {loading ?
                <Skeleton animation={"wave"} width={'100%'} style={{ backgroundColor: '#48D1CC' }}>
                </Skeleton>
                :

                <div>
                    <Grid container 
                    
                        alignItems="center"
                        justifyContent="center"
                    >

                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            align="flex-start"
                            item xs={12}
                            style={{ width: '100%', margin: 10, fontSize: 14, }}
                        >

                            <a href={"/gestao/administracao/clientes/gerenciarcliente/instalacao/gerenciarinstalacao/" + idInstalacao +"/" + idCliente} style={{ fontSize: 12, color: 'black', marginRight: '5px' }}>{"< " + returnDescricaoRetorno(instalacao)}</a>

                        </Grid>

                        <Grid
                            item xs={12}
                            container
                            direction="row"
                            alignItems="center"
                            justifyContent={"center"}
                            style={{margin: 0}}
                        >


                            <Box style={{ backgroundColor: 'white', width: '100%', alignItems: 'center' }}>
                                <AppBar position="static" >

                                    <Tabs
                                        value={value}
                                        onChange={handleChange}
                                        indicatorColor="secondary"
                                        textColor="inherit"
                                        variant="scrollable"
                                        scrollButtons="auto"
                                        aria-label="scrollable auto tabs example"


                                    >
                                        <Tab label="Informações Iniciais" style={{ backgroundColor: '#1C1C1C' }} />
                                        <Tab label="Propostas" style={{ backgroundColor: 'green' }} />
 
                                    </Tabs>
                                </AppBar>

                            </Box>
                        </Grid>


                        <SwipeableViews
                            index={value}
                            onChangeIndex={handleChangeIndex}
                            style={{ backgroundColor: 'white', width: '100%', alignItems: 'center', }}
                        >

                            <Grid
                                value={value} index={0}
                                container
                                direction="row"
                                item xs={12}
                                alignItems="flex-start"
                                justifyContent="flex-start"
                                spacing={2}
                            >

                                 <CabecalhoInformacoes
                                      projeto={projeto} 
                                        />

                            </Grid>

                            <Grid
                                value={value} index={1}
                                container
                                direction="row"
                                item xs={12}
                                alignItems="center"
                                justifyContent="center"
                            >
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-end"
                                    alignItems="center"
                                    item xs={12}
                                    style={{ padding: 10 }}
                                >
                                    <Button style={{ padding: 10 }}
                                        variant="contained"
                                        color="primary"
                                        onClick={novaProposta}
                                    >
                                        Nova Proposta
                                    </Button>
                                </Grid>


   <div>
                                            <div style={{ backgroundColor: 'white' }}>
                                                {propostas !== null && (
                                                    <>
                                                        <DataGrid
                                                            pagination
                                                             rows={propostas}
                                                            getRowId={(row) => row.id_proposta}
                                                            columns={columnsPropostasDataGrid}
                                                            disableColumnResize={false}
                                                            onCellClick={handleCellClick}
                                                            onRowClick={handleRowClick}
                                                            components={{
                                                                Toolbar: CustomToolbar,
                                                            }}
                                                        />



                                                    </>

                                                )}
                                            </div>
                                        </div>
                                





                            </Grid>


                        </SwipeableViews>







                    </Grid>


                </div>
            }

        </div >
    );
}


